/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcRouteV1FixSessionState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_ROUTE_V1_FIX_SESSION_STATE_ENTITY_NAME = 'exc.route.v1.FixSession';
export const excRouteV1FixSessionStateEntity = new schema.Entity<ExcRouteV1FixSessionState>(EXC_ROUTE_V1_FIX_SESSION_STATE_ENTITY_NAME, {}, { idAttribute: 'sessionId' });

